// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activity-table {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.activity-table__upper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
}
.activity-table__upper__controls {
  display: flex;
  flex-direction: row;
  justify-content: end;
  height: fit-content;
  gap: 0.5rem;
}
.activity-table__upper__controls__add-button {
  width: fit-content;
  height: 40px;
  background-color: #4F4BFF;
  color: white;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.activity-table__upper__controls__filter-button {
  width: fit-content;
  height: 40px;
  background-color: transparent;
  color: black;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.activity-table__table {
  height: 90%;
}
.activity-table__table__header {
  position: sticky;
  padding: 10px 1rem;
  display: grid;
  grid-template-columns: 5% 20% 20% 20% 20% 20%;
  place-items: center;
  background-color: #F9FAFB;
  border-radius: 7px;
  height: 8%;
  font-size: 0.85rem;
}
.activity-table__table__header > div:not(:first-child) {
  display: flex;
  justify-content: start;
  width: 100%;
}
.activity-table__table__body {
  height: 85%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow-x: hidden;
}
.activity-table__lower-controls {
  height: fit-content;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
}
.activity-table__lower-controls__rows-per-page, .activity-table__lower-controls__visible-rows {
  font-size: 0.85rem;
  color: #64748B;
  margin-right: 75px;
}
.activity-table__lower-controls__button {
  width: 110px;
  height: 40px;
  background-color: transparent;
  color: #726BEA;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
  margin-right: 10px;
}
.activity-table__lower-controls .disabled {
  color: #DEDEDE;
  pointer-events: none;
}

.p-checkbox.p-highlight .p-checkbox-box {
  background-color: #4F4BFF;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/activity-table/activity-table.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AAAI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAER;AADQ;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AAGZ;AAFY;EACI,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAIhB;AADY;EACI,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAGhB;AACI;EACI,WAAA;AACR;AAAQ;EACI,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,6CAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AAEZ;AAAgB;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAEhB;AAEQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;AAAZ;AAGI;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;AADR;AAGQ;EAEI,kBAAA;EACA,cAAA;EACA,kBAAA;AAFZ;AAKQ;EACI,YAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAHZ;AAKQ;EACI,cAAA;EACA,oBAAA;AAHZ;;AAQA;EACI,yBAAA;AALJ","sourcesContent":[".activity-table{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    &__upper{\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: end;\n        &__controls{\n            display: flex;\n            flex-direction: row;\n            justify-content: end;\n            height: fit-content;\n            gap: 0.5rem;\n            &__add-button{\n                width: fit-content;\n                height: 40px;\n                background-color:#4F4BFF;\n                color: white;\n                border-color: #DEDEDE;\n                border-radius: 6px;\n                font-size: 0.85rem;\n            }\n\n            &__filter-button{\n                width: fit-content;\n                height: 40px;\n                background-color:transparent;\n                color: black;\n                border-color: #DEDEDE;\n                border-radius: 6px;\n                font-size: 0.85rem;\n            }\n        }\n    }\n    &__table{\n        height: 90%;\n        &__header{\n            position: sticky;\n            padding: 10px 1rem;\n            display: grid;\n            grid-template-columns: 5% 20% 20% 20% 20% 20% ;\n            place-items: center;\n            background-color: #F9FAFB;\n            border-radius: 7px;\n            height: 8%;\n            font-size: 0.85rem;\n            >div{\n                &:not(:first-child){\n                display: flex;\n                justify-content: start;\n                width: 100%;\n                }\n            }\n        }\n        &__body{\n            height: 85%;\n            display: flex;\n            flex-direction: column;\n            gap: 0.5rem;\n            overflow-x: hidden;\n        }\n    }\n    &__lower-controls{\n        height: fit-content;\n        display: flex;\n        flex-direction: row;\n        justify-content: end;\n        align-items: center;\n\n        &__rows-per-page,\n        &__visible-rows{\n            font-size: 0.85rem;\n            color: #64748B;\n            margin-right: 75px;\n        }\n        \n        &__button{\n            width: 110px;\n            height: 40px;\n            background-color:transparent;\n            color: #726BEA;\n            border-color: #DEDEDE;\n            border-radius: 6px;\n            font-size: 0.85rem;\n            margin-right: 10px;\n        }\n        .disabled{\n            color: #DEDEDE;\n            pointer-events: none;\n        }\n    }\n}\n\n.p-checkbox.p-highlight .p-checkbox-box{\n    background-color: #4F4BFF ;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
